var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitationCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 0H5.8C2.2 0 0 2.2 0 5.8v8.4C0 17.8 2.2 20 5.8 20h8.4c3.6 0 5.8-2.2 5.8-5.8V5.8C20 2.2 17.8 0 14.2 0Zm.8 15.3H5a.8.8 0 0 1-.8-.8c0-.4.4-.8.8-.8h10c.4 0 .8.4.8.8s-.4.8-.8.8Zm0-4.6H5a.8.8 0 0 1-.8-.7c0-.4.4-.8.8-.8h10c.4 0 .8.4.8.8s-.4.8-.8.8Zm0-4.4H5a.8.8 0 0 1-.8-.8c0-.4.4-.8.8-.8h10c.4 0 .8.4.8.8s-.4.8-.8.8Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationCard);
export default __webpack_public_path__ + "static/media/invitationCard.86afef73ec789d2f8d75db7d4284d6f9.svg";
export { ForwardRef as ReactComponent };